import React, { FC, useEffect } from 'react'
import { FormModal, IFormModalProps } from 'transfix-ui/components/Modals'
import { Box, Typography } from 'transfix-ui/core'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { CarrierSetupContainer } from './CarrierSetupContainer'

type TOmittedProps = 'size' | 'title' | 'headerClassName' | 'open' | 'isClose' | 'children'

interface ICarrierSetupModalProps extends Omit<IFormModalProps, TOmittedProps> {}

export const CarrierSetupModal: FC<ICarrierSetupModalProps> = props => {
  const { trackEvent } = useFMSAnalytics()

  useEffect(() => {
    trackEvent('Setup Guide', 'VIEWED_GET_SET_UP_TO_BOOK_LOADS_MODAL')
  }, [trackEvent])

  return (
    <FormModal
      size={5}
      title='Get Set Up to Book Loads'
      headerClassName='pb2'
      open
      isClose
      dataTest='carrier-setup-modal'
      {...props}>
      <Box paddingTop={0} paddingBottom={4}>
        <Typography variant='body2'>
          We’ll ask you to submit your documents and provide insurance contact details. You’ll be
          notified when your carrier is approved to book loads.
        </Typography>
        <CarrierSetupContainer />
      </Box>
    </FormModal>
  )
}
